import { gql } from '@apollo/client';

export const CUSTOMER_CART_ID_QUERY = gql`
  query CustomerCartIdQuery {
    magento2 {
      customerCart {
        id
      }
    }
  }
`;

export const MERGE_CARTS_MUTATION = gql`
  mutation MergeCartsMutation($sourceId: String!, $destinationId: String!) {
    magento2 {
      mergeCarts(
        source_cart_id: $sourceId
        destination_cart_id: $destinationId
      ) {
        id
      }
    }
  }
`;

export const CREATE_EMPTY_CART_MUTATION = gql`
  mutation CreateEmptyCartMutation {
    magento2 {
      createEmptyCart
    }
  }
`;

export const CHECK_GUEST_CART_QUERY = gql`
  query CheckGuestCartQuery($id: String!) {
    magento2 {
      cart(cart_id: $id) {
        id
      }
    }
  }
`;
